/**
 * Cross-border interconnector maximum observed capacities (MW)
 * Generated by scripts/discover_interconnector_capacities.py
 * Generated: 2026-02-20T14:09:35.747084
 *
 * max_import_mw: peak flow observed FROM the border country INTO the home country
 * max_export_mw: peak flow observed FROM the home country INTO the border country
 *
 * Values are derived from historical ENTSO-E crossborder flow data.
 * These represent observed maximums, not physical NTC limits.
 */
export const INTERCONNECTOR_CAPACITIES = {
  AT: {
    CH: { max_import_mw: 1821.3, max_export_mw: 2244.0 },
    CZ: { max_import_mw: 3069.0, max_export_mw: 1314.0 },
    DE: { max_import_mw: 4063.0, max_export_mw: 3539.0 },
    HU: { max_import_mw: 1653.0, max_export_mw: 2118.0 },
    IT: { max_import_mw: 339.0, max_export_mw: 501.0 },
    SI: { max_import_mw: 1635.0, max_export_mw: 1983.0 },
  },
  BA: {
    HR: { max_import_mw: 1634.0, max_export_mw: 1848.0 },
    ME: { max_import_mw: 777.0, max_export_mw: 1231.0 },
    RS: { max_import_mw: 808.0, max_export_mw: 711.0 },
  },
  BE: {
    DE: { max_import_mw: 1003.0, max_export_mw: 1014.0 },
    FR: { max_import_mw: 5496.0, max_export_mw: 5752.0 },
    LU: { max_export_mw: 324.0 },
    NL: { max_import_mw: 4424.3, max_export_mw: 4308.0 },
    UK: { max_import_mw: 1003.0, max_export_mw: 1050.0 },
  },
  BG: {
    GR: { max_import_mw: 977.0, max_export_mw: 1106.0 },
    MK: { max_import_mw: 398.8, max_export_mw: 724.0 },
    RO: { max_import_mw: 1910.9, max_export_mw: 2467.0 },
    RS: { max_import_mw: 540.0, max_export_mw: 934.0 },
  },
  CH: {
    AT: { max_import_mw: 2244.0, max_export_mw: 1821.3 },
    DE: { max_import_mw: 5315.6, max_export_mw: 4589.0 },
    FR: { max_import_mw: 5061.0, max_export_mw: 4451.0 },
    IT: { max_import_mw: 3573.0, max_export_mw: 5441.0 },
  },
  CZ: {
    AT: { max_import_mw: 1314.0, max_export_mw: 3069.0 },
    DE: { max_import_mw: 3145.0, max_export_mw: 3951.0 },
    PL: { max_import_mw: 2326.0, max_export_mw: 1719.0 },
    SK: { max_import_mw: 1947.0, max_export_mw: 2922.0 },
  },
  DE: {
    AT: { max_import_mw: 3539.0, max_export_mw: 4063.0 },
    BE: { max_import_mw: 1014.0, max_export_mw: 1003.0 },
    CH: { max_import_mw: 4589.0, max_export_mw: 5315.6 },
    CZ: { max_import_mw: 3951.0, max_export_mw: 3145.0 },
    DK: { max_import_mw: 3828.0, max_export_mw: 3815.0 },
    FR: { max_import_mw: 4909.1, max_export_mw: 4927.0 },
    LU: { max_export_mw: 857.0 },
    NL: { max_import_mw: 6305.8, max_export_mw: 5457.0 },
    NO: { max_import_mw: 1408.0, max_export_mw: 1449.0 },
    PL: { max_import_mw: 2387.0, max_export_mw: 2820.3 },
    SE: { max_import_mw: 217.2, max_export_mw: 602.0 },
  },
  DK: {
    DE: { max_import_mw: 3815.0, max_export_mw: 3828.0 },
    NL: { max_import_mw: 706.0, max_export_mw: 835.0 },
    NO: { max_import_mw: 1703.0, max_export_mw: 1687.0 },
    SE: { max_import_mw: 2071.7, max_export_mw: 2497.0 },
  },
  EE: {
    FI: { max_import_mw: 1033.1, max_export_mw: 924.0 },
    LV: { max_import_mw: 823.0, max_export_mw: 895.0 },
  },
  ES: {
    FR: { max_import_mw: 3872.0, max_export_mw: 3941.0 },
    PT: { max_import_mw: 3971.0, max_export_mw: 4787.0 },
  },
  FI: {
    EE: { max_import_mw: 924.0, max_export_mw: 1033.1 },
    NO: { max_import_mw: 135.0, max_export_mw: 100.0 },
    SE: { max_import_mw: 3381.1, max_export_mw: 2260.0 },
  },
  FR: {
    BE: { max_import_mw: 5752.0, max_export_mw: 5496.0 },
    CH: { max_import_mw: 4451.0, max_export_mw: 5061.0 },
    DE: { max_import_mw: 4927.0, max_export_mw: 4909.1 },
    ES: { max_import_mw: 3941.0, max_export_mw: 3872.0 },
    IT: { max_import_mw: 2142.4, max_export_mw: 9842.0 },
    UK: { max_import_mw: 3971.0, max_export_mw: 4089.0 },
  },
  GR: {
    BG: { max_import_mw: 1106.0, max_export_mw: 977.0 },
    IT: { max_import_mw: 508.8, max_export_mw: 514.0 },
    MK: { max_import_mw: 1021.0, max_export_mw: 1317.0 },
  },
  HR: {
    BA: { max_import_mw: 1848.0, max_export_mw: 1634.0 },
    HU: { max_import_mw: 1923.0, max_export_mw: 1061.0 },
    RS: { max_import_mw: 781.0, max_export_mw: 857.0 },
    SI: { max_import_mw: 2448.0, max_export_mw: 2046.0 },
  },
  HU: {
    AT: { max_import_mw: 2118.0, max_export_mw: 1653.0 },
    HR: { max_import_mw: 1061.0, max_export_mw: 1923.0 },
    RO: { max_import_mw: 854.0, max_export_mw: 2816.5 },
    RS: { max_import_mw: 697.0, max_export_mw: 928.0 },
    SK: { max_import_mw: 3812.0, max_export_mw: 2049.0 },
    UA: { max_export_mw: 1244.0 },
  },
  IE: {
    UK: { max_import_mw: 1044.0, max_export_mw: 1004.0 },
  },
  IT: {
    AT: { max_import_mw: 501.0, max_export_mw: 339.0 },
    CH: { max_import_mw: 5441.0, max_export_mw: 3573.0 },
    FR: { max_import_mw: 9842.0, max_export_mw: 2142.4 },
    GR: { max_import_mw: 514.0, max_export_mw: 508.8 },
    MT: { max_import_mw: 161.0, max_export_mw: 368.0 },
    SI: { max_import_mw: 1714.0, max_export_mw: 1248.0 },
  },
  LT: {
    LV: { max_import_mw: 1214.0, max_export_mw: 1064.0 },
    PL: { max_import_mw: 973.9, max_export_mw: 649.0 },
    SE: { max_import_mw: 733.8, max_export_mw: 700.0 },
  },
  LU: {
    BE: { max_import_mw: 324.0 },
    DE: { max_import_mw: 857.0 },
  },
  LV: {
    EE: { max_import_mw: 895.0, max_export_mw: 823.0 },
    LT: { max_import_mw: 1064.0, max_export_mw: 1214.0 },
  },
  ME: {
    BA: { max_import_mw: 1231.0, max_export_mw: 777.0 },
    RS: { max_import_mw: 629.0, max_export_mw: 788.0 },
  },
  MK: {
    BG: { max_import_mw: 724.0, max_export_mw: 398.8 },
    GR: { max_import_mw: 1317.0, max_export_mw: 1021.0 },
    RS: { max_import_mw: 636.0, max_export_mw: 525.0 },
  },
  MT: {
    IT: { max_import_mw: 368.0, max_export_mw: 161.0 },
  },
  NL: {
    BE: { max_import_mw: 4308.0, max_export_mw: 4424.3 },
    DE: { max_import_mw: 5457.0, max_export_mw: 6305.8 },
    DK: { max_import_mw: 835.0, max_export_mw: 706.0 },
    NO: { max_import_mw: 707.0, max_export_mw: 732.0 },
    UK: { max_import_mw: 1075.8, max_export_mw: 1103.5 },
  },
  NO: {
    DE: { max_import_mw: 1449.0, max_export_mw: 1408.0 },
    DK: { max_import_mw: 1687.0, max_export_mw: 1703.0 },
    FI: { max_import_mw: 100.0, max_export_mw: 135.0 },
    NL: { max_import_mw: 732.0, max_export_mw: 707.0 },
    SE: { max_import_mw: 4353.0, max_export_mw: 3569.0 },
    UK: { max_import_mw: 1400.0, max_export_mw: 1473.0 },
  },
  PL: {
    CZ: { max_import_mw: 1719.0, max_export_mw: 2326.0 },
    DE: { max_import_mw: 2820.3, max_export_mw: 2387.0 },
    LT: { max_import_mw: 649.0, max_export_mw: 973.9 },
    SE: { max_import_mw: 597.7, max_export_mw: 638.0 },
    SK: { max_import_mw: 885.0, max_export_mw: 1736.0 },
    UA: { max_export_mw: 741.2 },
  },
  PT: {
    ES: { max_import_mw: 4787.0, max_export_mw: 3971.0 },
  },
  RO: {
    BG: { max_import_mw: 2467.0, max_export_mw: 1910.9 },
    HU: { max_import_mw: 2816.5, max_export_mw: 854.0 },
    RS: { max_import_mw: 1391.7, max_export_mw: 862.0 },
    UA: { max_export_mw: 764.0 },
  },
  RS: {
    BA: { max_import_mw: 711.0, max_export_mw: 808.0 },
    BG: { max_import_mw: 934.0, max_export_mw: 540.0 },
    HR: { max_import_mw: 857.0, max_export_mw: 781.0 },
    HU: { max_import_mw: 928.0, max_export_mw: 697.0 },
    ME: { max_import_mw: 788.0, max_export_mw: 629.0 },
    MK: { max_import_mw: 525.0, max_export_mw: 636.0 },
    RO: { max_import_mw: 862.0, max_export_mw: 1391.7 },
  },
  SE: {
    DE: { max_import_mw: 602.0, max_export_mw: 217.2 },
    DK: { max_import_mw: 2497.0, max_export_mw: 2071.7 },
    FI: { max_import_mw: 2260.0, max_export_mw: 3381.1 },
    LT: { max_import_mw: 700.0, max_export_mw: 733.8 },
    NO: { max_import_mw: 3569.0, max_export_mw: 4353.0 },
    PL: { max_import_mw: 638.0, max_export_mw: 597.7 },
  },
  SI: {
    AT: { max_import_mw: 1983.0, max_export_mw: 1635.0 },
    HR: { max_import_mw: 2046.0, max_export_mw: 2448.0 },
    IT: { max_import_mw: 1248.0, max_export_mw: 1714.0 },
  },
  SK: {
    CZ: { max_import_mw: 2922.0, max_export_mw: 1947.0 },
    HU: { max_import_mw: 2049.0, max_export_mw: 3812.0 },
    PL: { max_import_mw: 1736.0, max_export_mw: 885.0 },
    UA: { max_export_mw: 1141.0 },
  },
  UK: {
    BE: { max_import_mw: 1050.0, max_export_mw: 1003.0 },
    FR: { max_import_mw: 4089.0, max_export_mw: 3971.0 },
    IE: { max_import_mw: 1004.0, max_export_mw: 1044.0 },
    NL: { max_import_mw: 1103.5, max_export_mw: 1075.8 },
    NO: { max_import_mw: 1473.0, max_export_mw: 1400.0 },
  },
};

export const getInterconnectorCapacity = (homeCountry, borderCountry) => {
  return INTERCONNECTOR_CAPACITIES[homeCountry]?.[borderCountry] ?? null;
};

export const getInterconnectorMaxVolume = (homeCountry, borderCountry) => {
  const cap = getInterconnectorCapacity(homeCountry, borderCountry);
  if (!cap) return null;
  const peak = Math.max(cap.max_import_mw ?? 0, cap.max_export_mw ?? 0);
  if (peak === 0) return null;
  const step = peak < 1000 ? 100 : 500;
  return Math.ceil(peak / step) * step;
};
